import { useEffect, useState } from "react";
import api from "../utils/api";
import { getStatusLabel } from "../utils/statusLabel";
import moment from "moment";
import { useLocation } from "react-router-dom";

const ItemReceiverDetails = props => {

    const location = useLocation();
    const isOnDashboard = location.pathname === "/dash";

    const [isLoadingHistory, setIsLoadingHistory] = useState(false);
    const [history, setHistory] = useState([]);

    useEffect(() => {
        if(props?.receiver){
            getHistory();
        }
    }, [props?.receiver])  
    
    const getHistory = () => {

        setIsLoadingHistory(true);

        api.get(`/receiver/history/${props?.receiver}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(function (res) {
            setHistory(res.data);
            setIsLoadingHistory(false);
        })
        .catch(err => {
            setIsLoadingHistory(false);
        });

    }

    const cardBg = isOnDashboard ? "bg-white" : "bg-gray-100";

    return(
        <>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
                <div className={`p-4 ${cardBg} rounded-lg`}>
                    <p className="text-sm text-gray-500">Total recebido</p>
                    {isLoadingHistory ?
                        <div className="h-7 mt-2 w-24 bg-gray-300 animate-pulse rounded-md"></div>
                    :
                        <p className="text-lg font-semibold text-green-700">
                            {(history?.total_paid ?? 0)?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </p>
                    }
                </div>
                <div className={`p-4 ${cardBg} rounded-lg`}>
                    <p className="text-sm text-gray-500">Total a receber</p>
                    {isLoadingHistory ?
                        <div className="h-7 mt-2 w-24 bg-gray-300 animate-pulse rounded-md"></div>
                    :
                        <p className="text-lg font-semibold text-green-700">
                            {(history?.total_to_paid ?? 0)?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </p>
                    }
                </div>
                {/* <div className="p-4 ${cardBg} rounded-lg">
                    <p className="text-sm text-gray-500">Recebimentos</p>
                    <p className="text-lg font-semibold text-blue-700">
                        {quantidadeRecebimentos}
                    </p>
                </div> */}
                <div className={`p-4 ${cardBg} rounded-lg`}>
                    <p className="text-sm text-gray-500">Ticket médio</p>
                    {isLoadingHistory ?
                        <div className="h-7 mt-2 w-24 bg-gray-300 animate-pulse rounded-md"></div>
                    :
                        <p className="text-lg font-semibold text-yellow-700">
                            {(history?.ticket ?? 0)?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </p>
                    }
                </div>
            </div>
            {isLoadingHistory ?
                <div className="h-7 mt-4 w-full bg-gray-300 animate-pulse rounded-md"></div>
            :
                <>
                    {history?.history?.length > 0 ?
                        <table className="min-w-full mt-4 border-collapse border border-gray-300">
                            <thead>
                                <tr className={`${cardBg} border-b`}>
                                    <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700 border border-gray-300">Data</th>
                                    <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700 border border-gray-300">Valor (%)</th>
                                    <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700 border border-gray-300">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {history?.history?.map((item, index) => (
                                    <tr className="border-b" key={index}>
                                        <td className="py-2 px-4 text-sm text-gray-700 border border-gray-300">{moment(item?.date).format('DD/MM/YYYY')}</td>
                                        <td className="py-2 px-4 text-sm text-gray-700 border border-gray-300">{item?.value && parseFloat(item?.value ?? 0).toLocaleString('pt-BR',{style: 'currency', currency:'BRL'})} ({item?.percentage}%)</td>
                                        <td className="py-2 px-4 text-sm text-gray-700 border border-gray-300">{getStatusLabel(item?.status)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    :
                        <p className="mt-4 text-sm text-gray-500">Sem histórico até o momento</p>
                    }
                </>
            }
        </>
    )
}

export default ItemReceiverDetails;